import React from 'react';
import { Col, DatePicker, Radio, Row, Select, TreeSelect, Input, Icon } from 'antd';
import moment from 'moment';

import SelectPlaceHolder from '../../../components/SelectPlaceHolder';

export default class Filters extends React.Component {


    onLoadData = treeNode =>
        new Promise(resolve => {
            const { id } = treeNode.props;
            setTimeout(() => {
                this.props.onData(id)
                resolve();
            }, 100);
        });


    render() {
        return (
            <div className="filfer-container">
                <Row gutter={16} align="middle">

                    <Col className="gutter-row" sm={24} md={12} lg={6}>
                        <Select showSearch labelInValue
                            value={this.props.filter.idEstablecimiento ? { key: this.props.filter.idEstablecimiento } : undefined}
                            placeholder={<SelectPlaceHolder label="Filtrar por Establecimiento" />}
                            onChange={(option) => this.props.onChange("idEstablecimiento", option.key)}
                            optionFilterProp="children"
                        >
                            {this.props.establecimientos.map(item => (
                                <Select.Option key={item.id}>{item.nombre}</Select.Option>
                            ))}
                        </Select>
                    </Col>
                    <Col className="gutter-row" sm={24} md={12} lg={3}>
                        <Select showSearch labelInValue
                            value={this.props.filter.idAlmacen ? { key: this.props.filter.idAlmacen } : undefined}
                            placeholder={<SelectPlaceHolder label="Filtrar por Almacen" />}
                            onChange={(option) => this.props.onChange("idAlmacen", option.key)}
                            optionFilterProp="children"
                        >
                            {this.props.almacenes.map(item => (
                                <Select.Option key={item.id}>{item.nombre}</Select.Option>
                            ))}
                        </Select>
                    </Col>

                    <Col className="gutter-row" sm={24} md={12} lg={6}>
                        <Select showSearch labelInValue
                            value={this.props.filter.idVendedor ? { key: this.props.filter.idVendedor } : undefined}
                            placeholder={<SelectPlaceHolder label="Filtrar por Vendedor" />}
                            onChange={(option) => this.props.onChange("idVendedor", option.key)}
                            optionFilterProp="children"
                        >
                            {this.props.vendedores.map(item => (
                                <Select.Option key={item.id}>{item.razonSocialEntidad}</Select.Option>
                            ))}
                        </Select>
                    </Col>
                    <Col className="gutter-row" sm={24} md={12} lg={6}>
                        <Select showSearch labelInValue
                            value={this.props.filter.idProyecto ? { key: this.props.filter.idProyecto } : undefined}
                            placeholder={<SelectPlaceHolder label="Filtrar por Proyecto" />}
                            onChange={(option) => this.props.onChange("idProyecto", option.key)}
                            optionFilterProp="children"
                        >
                            {this.props.proyectos.map(item => (
                                <Select.Option key={item.id}>{item.nombre}</Select.Option>
                            ))}
                        </Select>
                    </Col>
                    <Col className="gutter-row" sm={24} md={12} lg={3}>
                        <DatePicker
                            placeholder="Filtrar por fecha inicio"
                            format="DD/MM/YYYY"
                            value={this.props.filter.fechaInicioStr === '' ? null : moment(this.props.filter.fechaInicioStr, 'DD/MM/YYYY')}
                            onChange={(moment, value) => this.props.onChange('fechaInicioStr', value)}
                        />
                    </Col>
                    <Col className="gutter-row" sm={24} md={12} lg={3}>
                        <DatePicker
                            placeholder="Filtrar por fecha fin"
                            format="DD/MM/YYYY"
                            value={this.props.filter.fechaFinStr === '' ? null : moment(this.props.filter.fechaFinStr, 'DD/MM/YYYY')}
                            onChange={(moment, value) => this.props.onChange('fechaFinStr', value)}
                        />
                    </Col>

                    {/*                    <Col className="gutter-row" sm={24} md={12} lg={6}>
                        <Select showSearch labelInValue
                            defaultActiveFirstOption={false}

                            value={this.props.filter.idProducto ? { key: this.props.filter.idProducto } : undefined}
                            placeholder={<SelectPlaceHolder label="Filtrar por Producto" />}
                            onChange={(option) => this.props.onChange("idProducto", option.key)}
                            onSearch={this.props.onSearch}

                            optionFilterProp="children"
                        >
                            {this.props.productos.map(item => (
                                <Select.Option key={item.id}>{item.nombre}</Select.Option>
                            ))}
                        </Select>
                    </Col> */}



                    <Col className="gutter-row" sm={24} md={12} lg={5}>
                        <TreeSelect
                            treeDataSimpleMode
                            style={{ width: '100%' }}
                            value={this.props.filter.idCategoria == 0 ? undefined : this.props.filter.idCategoria}
                            dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                            placeholder="Categoria"
                            onChange={(value) => this.props.onChange("idCategoria", value)}
                            loadData={this.onLoadData}
                            treeData={this.props.categorias}
                        />
                    </Col>

                    <Col className="gutter-row" sm={24} md={12} lg={5}>
                        <Input
                            prefix={<Icon type="filter" style={{ color: 'rgba(0,0,0,.25)' }} />}
                            value={this.props.filter.lote}
                            onChange={(e) => this.props.onChange("lote", e.target.value)}
                            placeholder="Filtrar por lote"
                            autoComplete="off"
                            onKeyUp={this.props.onKeyUpSearch}

                        />
                    </Col>

                    <Col className="gutter-row" sm={24} md={12} lg={6}>
                        <Input
                            prefix={<Icon type="filter" style={{ color: 'rgba(0,0,0,.25)' }} />}
                            value={this.props.filter.referencia}
                            onChange={(e) => this.props.onChange("referencia", e.target.value)}
                            placeholder="Filtrar por nombre o codigo referencia"
                            autoComplete="off"
                            onKeyUp={this.props.onKeyUpSearch}

                        />
                    </Col>

                    <Col className="gutter-row" sm={24} md={12} lg={8} xl={6} hidden>
                        <Select
                            showSearch
                            labelInValue
                            value={
                                this.props.filter.idCultivo ?
                                    { key: this.props.filter.idCultivo } : undefined
                            }
                            placeholder={<SelectPlaceHolder label="Filtrar por cultivo" />}
                            onChange={(option) => this.props.onChange("idCultivo", option.key)} //STATE PROPERTY
                            optionFilterProp="children"
                        >
                            {this.props.cultivos.map(item => ( //STATE DATA
                                <Select.Option value={item.id} key={item.id}>{item.nombre}</Select.Option>
                            ))}
                        </Select>
                    </Col>


                    <Col className="gutter-row" sm={24} md={12} lg={8} xl={6} hidden>
                        <Select
                            showSearch
                            labelInValue
                            value={
                                this.props.filter.idFenologica ?
                                    { key: this.props.filter.idFenologica } : undefined
                            }
                            placeholder={<SelectPlaceHolder label="Filtrar por fenologica" />}
                            onChange={(option) => this.props.onChange("idFenologica", option.key)} //STATE PROPERTY
                            optionFilterProp="children"
                        >
                            {this.props.fenologicas.map(item => ( //STATE DATA
                                <Select.Option value={item.id} key={item.id}>{item.nombre}</Select.Option>
                            ))}
                        </Select>
                    </Col>

                    <Col className="gutter-row" sm={24} md={12} lg={3} hidden>
                        <Select showSearch labelInValue
                            value={this.props.filter.idMoneda ? { key: this.props.filter.idMoneda } : undefined}
                            placeholder={<SelectPlaceHolder label="Filtrar por Moneda" />}
                            onChange={(option) => this.props.onChange("idMoneda", option.key)}
                            optionFilterProp="children"
                        >
                            {this.props.monedas.map(item => (
                                <Select.Option key={item.id}>{item.nombre}</Select.Option>
                            ))}
                        </Select>
                    </Col>
                    <Col className="gutter-row" sm={24} md={12} lg={6}>
                        <Select showSearch labelInValue
                            value={this.props.filter.idCliente ? { key: this.props.filter.idCliente } : undefined}
                            placeholder={<SelectPlaceHolder label="Filtrar por Cliente" />}
                            onChange={(option) => this.props.onChange("idCliente", option.key)}
                            optionFilterProp="children"
                        >
                            {this.props.clientes.map(item => (
                                <Select.Option key={item.id}>{item.nombre}</Select.Option>
                            ))}
                        </Select>
                    </Col>



                    <Col className="gutter-row" sm={24} md={24} lg={24}>
                        <div style={{ height: '32px', display: 'flex', alignItems: 'left', justifyContent: 'left' }} >
                            <Radio.Group
                                value={this.props.filter.tipoComprobante}
                                onChange={(e) => this.props.onChange("tipoComprobante", e.target.value)}
                            >
                                <Radio value={1}>Solo comprobantes tributarios</Radio>
                                <Radio value={2}>Solo notas de ventas</Radio>
                                <Radio value={0}>Todos los comprobantes</Radio>
                            </Radio.Group>
                        </div>
                    </Col>

                </Row>
            </div>
        );
    }
}